var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewHairstyle1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type5_x5F_new_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_x5F_1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M486.7,187c-9-35.2-20.6-63.3-43.2-91.5c-8.2-10.3-28.2-25.1-41.2-26.2c-18.2-1.6-29.5,2.4-44.9,10.7 c-15.4-8.3-25.1-11.7-44.1-9.1c-15.3,2.1-33.8,14.4-42,24.7c-22.6,28.2-34.2,56.3-43.2,91.5c-17,66.1-13.1,136.3-11.5,204.1 c2,81.3,2,165.3,4,246.6c8.5-1.9,20.2-2.5,28.5-0.9l0,0l0,0l2.5,1.4l0.7-50l8,46.5v-0.2c0.1,0.8,0.1,1.5,0.1,1.5l6.6-21.4l1.6,26 c15.1-3.5,38.1-5.5,53.6,0.7l-4.6-243.9c-3.2-2.9-7.3-6.3-10-9c-12.2-12.2-19.1-20.2-28.1-35c-6.8-11.1-13.1-32.7-14.4-48.7 c-8.2,3.5-14.5-4.8-18-16c-3.3-10.6-5.5-21.4-3.5-32.8c3.8-20.8,8.8-19.5,13-19.5c9.3,2.1,7,37.8,9.5,50.5 c2.5-27,0.7-37.9,5.8-53.8c7.5-5.2,10.2-8,16.2-14.5c3.7-4,5.6-6.9,8.3-11.6s5-9.6,7-14.2c0.4-0.9,0.8-1.7,1.2-2.6 c1.9-0.6,3.7-1.1,5.6-1.7c6.2-1.8,12.5-3.3,18.8-4.4l0,0c0.3-0.1,0.6-0.1,0.9-0.2c1.2-0.2,2.5-0.4,3.7-0.6l0,0 c1.9-8.9,5.4-21.3,8.9-25.8c-2,6.3-3.6,17.9-3.2,25.2c0.6-0.1,1.3-0.1,2-0.2l0,0c4.5-0.4,9.1-0.5,13.8-0.4 c4.7,0.1,10,0.4,15.6,0.8c0.9-4.2,1.3-9.3,1.5-13.5c1.6,4.2,3.3,10.2,3.7,13.9c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0.1,2.1,0.2 c2.6,0.3,5.2,0.6,7.8,1c-0.9-14.1-5.9-27.5-9.7-36.2c0.1,0.1,0.1,0.1,0.2,0.2c2,2.2,4.3,6.1,5.7,8.7c0.7,1.2,5.6,8,11.6,28.8 c0.9,0.2,1.8,0.4,2.7,0.6c1.2,0.3,2.4,0.6,3.5,0.9c3.7,1,7.3,2.2,10.5,3.6c0.3,0.6,0.6,1.2,0.9,1.8c2,4.6,4.3,9.4,7,14.2 c2.7,4.7,5.4,8.1,8.8,12.4c6.6,8.1,11.2,11.6,18.2,15.2c5.1,15.9,5.2,25.4,5.8,43.5c2-14.9,2.2-30.8,10-41.8 c4.8,1.6,10.8,4.5,12.2,21.5c1,11.5-4.1,21.6-6.5,32.5c-2.2,10.3-8,15-14.5,13.8c-0.1,0-0.9,11.8-1,11.8 c-6.8,37-30.8,62.2-55.2,84.5l-3.6,238.2c8.4-2.5,22-3.6,31.5-1.8v0.2l3.6,1.3l-1-56.1l9,52.6l6.4-25.3l-6.4,25.2l0.2,1.7 l6.7-20.7l1.5,24.9c14-3.2,34.7-5.2,50.1-0.6c2-82.1,2-167,4-249C499.8,323.4,503.7,253.2,486.7,187z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M348.5,132.1c2.6-2,4.9-3.9,9-6c14.3,7,25.7,18.3,36.8,32.8c-3.7-6.2-7.6-11.9-11.9-16.5 c-4.1-4.5-8.5-8.7-13.4-12.3c-3.6-2.7-7.5-5.2-11.6-7.3c-4.1,2.1-8,4.6-11.6,7.3c-4.9,3.7-9.3,7.8-13.4,12.3 c-7.7,8.1-14,19.5-20,31.8c-2.6,5.3-5.2,10.8-7.8,16.2c1.9-0.6,3.7-1.1,5.6-1.7C317.9,167.6,330.8,145.3,348.5,132.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M266.6,609.6l-6.4,25.1l0,0c0.1,0.8,0.1,1.5,0.1,1.5l6.6-21.4l0,0L266.6,609.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E1003",
    points: "442.2,609.6 435.7,634.8 435.9,636.5 442.5,615.8 442.5,615.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M424.9,571.3l0.7,65.8c-0.4-0.1-0.9-0.2-1.3-0.3l0,0v0.2l3.6,1.3l-1-56.1l0,0L424.9,571.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M249.3,571.3l0.7,65.8c-0.3-0.1-0.6-0.1-0.9-0.2l0,0l2.5,1.4l0.7-50l0,0L249.3,571.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M360.6,112.8c20.6-2,46.7,15.6,56.9,35.9c-9.7-27-34.8-41.6-56.4-38.4c0.4-2.5,0.8-5.1,0.9-7.8 c7.4-7,27.6-8.5,37.4-1.1c-9.1-10.7-30.2-7.9-37.3-2.1c0.1-2.4,0-4.9-0.3-7.1c11.6-14.4,37.2-18.2,52.1-7.9 c-13.9-13.4-39.6-8.6-52.5,5.1c-0.5-2.8-1.3-5.3-2.5-7.2c0.3,2.5,0.5,5.2,0.5,7.9c-6.8-5.4-16.4-8.8-26.7-7.6 c9.8,1,19.5,3.5,26.7,10.6c0,2.2-0.1,4.5-0.2,6.7c-12.1-10.2-36.6-10.3-46.7,3.3c11.1-10.4,34.6-12.3,46.4,0.4 c-0.1,2.3-0.3,4.5-0.5,6.7c-20.5-10.7-44.5,6-54,24.8c13.9-16.6,34-32.6,53.6-21.3l0.1-0.4c-0.3,3-0.5,5.9-0.6,8.5 C358.8,119.7,359.8,116.6,360.6,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M330.1,127.8L330.1,127.8c-26.1,16.3-34.7,43.8-50.2,69c-6.8,11.2-13.7,21.2-22.5,29.3 c-8.8,8-20,14.2-33,14.8c26.5-0.9,46-19.2,59.7-41.6C300.3,173.2,304,144.9,330.1,127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M261.1,211.3c11.1-14.8,14.7-29.8,23.1-45.1l0,0c-8.8,15-16.7,28.1-27,42.1c-8.9,11.8-18.4,22-33.3,25.9 C238.6,231.2,251.3,223.9,261.1,211.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M486.6,269.5L486.6,269.5c-0.1-12-3-23.7-11.2-32.3c-8.3-8-16.4-15.4-24.5-24.6 C437,197.2,426,182,421.7,161.4c3.5,20.5,11.3,38.2,25.6,54.5c8.2,9.5,17.6,16.5,26.2,23.3C481.9,246.2,486.3,257.5,486.6,269.5z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M440.4,114.7L440.4,114.7c17.5,18.3,24.1,39.2,33,62.6c7.1,20.7,16.1,37.7,17.4,59.4 c-0.6-21.7-5.9-40.1-12.9-61.1C469.1,151.7,458,132.3,440.4,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M258.4,160.9L258.4,160.9c-8.5,10.9-16,20.7-22.2,33.4c-5.4,11.1-7.8,21.7-10.8,33.3 c3.7-11.5,9.6-20.3,15.1-31.1C246.9,183.9,250.2,172.3,258.4,160.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M449,171.1c1.7,15.1,7.4,28.1,16.6,40.9c8,10.9,16.6,19,21,31.7c-3.6-12.8-9.2-23.6-17.1-34.6 C460.8,196.7,451.2,186.4,449,171.1L449,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M226.3,445.1c-0.5-52-1.8-96.3,3.2-147c-5.7,50.6-8.4,94.9-8.1,147.1c0.9,60.2,3.3,110.6,9.2,169.1v-0.1 C225.2,555.6,227.4,505.2,226.3,445.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M302.2,610.3L302.2,610.3c3.7-37.5,5.4-70,2.6-108.5c-2.5-33.3-7.8-61.3-11.7-93.7 c3.2,32.5,4.6,60.8,6.9,94C302.5,540.5,305.4,572.7,302.2,610.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M265.7,517.2c-0.1-1.9-0.4-3.8-0.6-5.8c0,0.6,0,1.1,0,1.7c-0.5,33.7,1.4,62.2-2.5,95.1v-0.1 c4.4-32.8,7.1-61.1,7.4-95c-0.1-29.4-2.9-54.2-4.4-82.8c0.6,22.4,0.1,42.5-0.3,64.1C266.7,502.7,267,510.9,265.7,517.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M251.5,546.2L251.5,546.2c0-15,0.2-28.8,0.2-42.8c-0.2,1.6-0.4,3.2-0.6,4.8l-1.5-12.6 c0.4-2.7,1.2-5.5,2-8.5c-0.1-6-0.2-12-0.4-18.3c-0.6-23.7-2.2-43.9,0.6-67.1c-3.5,23-5.9,43.3-5.5,67.2 C247,496.5,251,519.3,251.5,546.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M478.1,319.6c2.5,14.2,4.2,28,5.2,41.6c0-1.2,0-2.4-0.1-3.5c1,3.6,1.1,7.3,0.6,10.9 c2.3,35.5,0.9,70.1,0.3,108.8c-1.2,48.6-1.4,90.1-5,137.6c4.3-47.4,8.3-88.7,9.8-137.4c1-56.3-0.9-103.9-10.9-158H478.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M471.6,356.2c0.2,1.4,0.5,2.7,0.9,3.9c-1.7-11.2-4.2-21.9-6.8-33.5c3.3,17.6,3.3,33.3,4.3,51.4 c1.1,21,3,38.7,2.7,59.4l0,0c0.8-20.6,3.1-38.4,1.8-59.6c-0.2-2.6-0.4-5.1-0.7-7.6c-0.8-1.9-1.4-3.8-1.7-5.6L471.6,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M442,489c-1.1,39.5-1.6,72.8-4.9,111.5v-0.1c3.7-38.6,8.8-71.5,9.7-111.3c0.6-34.4-2.1-63.7-6.2-97 C444.1,425.5,442.9,454.8,442,489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M468,567.8c-2.3,21.6-3.4,40.1-8.3,61l0,0c5.3-20.7,11-38.4,13.1-60.5c1.7-19.1,0.1-35.4-1.4-53.8 C472.2,533.1,469.9,549.1,468,567.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M419.7,469.1c-0.8-27.3-2.6-50.7-0.3-77.5c-3,26.7-5.1,50.1-4.5,77.6c0.8,31.8,5.2,58.2,7.6,89.1v-0.1 C420.5,527.3,420.8,500.7,419.7,469.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M317.8,79L317.8,79c-17.8,4-32.2,12.8-44.3,27.4c-10.3,12.8-15.8,25.8-21.4,40.5 c6-14.7,13.6-26.3,23.6-38.7C287.5,94.3,299.8,83.4,317.8,79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M252.7,203.8L252.7,203.8c12.7-16.1,20.9-31.9,31-50c8.8-15.4,15.8-30.2,31.6-39 c-15.9,8.3-25.1,22.1-34.1,37.6C270.8,170.6,265.1,187.5,252.7,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M455.5,160.2c9.8,17.1,18,31.7,23.8,50.3l0,0c-5.4-18.6-10.3-34.9-20.4-52.2c-9-14.8-18.7-26.4-31.9-36.9 C439.8,132.4,446.8,145.6,455.5,160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M378.4,85.8c9.7-1.5,18.3,0,27.5,3.1c10.5,3.8,19.2,9,25.6,18.4l0,0c-6.1-9.4-13.8-16.3-24.9-20.2 C396.8,83.8,387.9,84,378.4,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M242.6,553.8L242.6,553.8c-3-36.4-4.3-67.7-4.9-104.8c-0.3-32.1-0.1-59.7,6.4-90.7 c-7,30.8-10.4,58.4-10.2,90.8C234.2,486.5,239.3,517.6,242.6,553.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M283.2,621L283.2,621L283.2,621L283.2,621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M288.9,548c-0.6-22.6-3.4-41.6-5.2-63.5c1.2,22,0.9,41.1,1.3,63.6c0.4,25.9,1.5,47.7-1.8,72.9 C287,595.9,289.5,574.1,288.9,548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M404.9,517.2c-0.1-28.5-1.3-52.7-1.9-80.6c0.1,27.9-1.9,52.1-2,80.6c0,33,2.4,60.6,5.7,92.6v-0.1 C403.7,577.7,405,550.1,404.9,517.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M455.5,346.9c4.1,31.3,4.3,58.7,4.2,90.8c-0.4,37.1-1.1,68.3-5.9,104.4V542c5.2-35.9,9.6-66.9,9.8-104.3 C463.5,405.4,460.2,378,455.5,346.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M387.2,101.7c-7-1.7-13.8-1.5-19.7,2.3c6.2-3.5,12.7-2,19.2-0.4c7.5,2.2,14.2,5.3,18.6,12 C401.2,108.8,395.3,104,387.2,101.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M405.3,115.6L405.3,115.6L405.3,115.6L405.3,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M344.5,89.8L344.5,89.8L344.5,89.8L344.5,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M287.3,121.7c5.2-10.2,12-17.8,21.5-24.2c11-7.1,22.7-10.3,35.7-7.7c-12.7-2.8-25.2-1.4-36.8,6.1 C297.8,102.6,292.2,111.5,287.3,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M352.7,137.5c-11.8,11.3-20.5,30.2-23.8,46.8l0,0c0.3-0.1,0.6-0.1,0.9-0.2c1.3-0.2,2.6-0.4,3.7-0.6 c1.9-8.9,5.4-21.3,8.9-25.8c-2,6.3-3.6,17.9-3.2,25.2c0.6-0.1,1.3-0.1,2-0.2l0,0C341,160.7,346.8,150.4,352.7,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M372.3,164.3c0,1.6-0.1,3.4-0.1,5.3c1.6,4.2,3.3,10.2,3.7,13.9c0.1,0,0.2,0,0.3,0 c0.7,0.1,1.4,0.1,2.1,0.2l0,0C377.2,177.5,375.3,170.5,372.3,164.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M376.6,148.7c2,2.2,4.3,6.1,5.7,8.7c0.7,1.2,5.6,8,11.6,28.8c0.9,0.2,1.8,0.4,2.7,0.6 c1.2,0.3,2.4,0.6,3.5,0.9l0,0C395.6,173,388.6,158.4,376.6,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M419.5,188.3c-5.5-13.5-9.9-25.4-11.9-39.8c1.5,14.4,2.8,27.2,8.4,41.3c6.6,16.1,16.3,27.7,28.8,38.7l0,0 C432.3,216.9,426,203.7,419.5,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M251.1,508.3c0.2-1.6,0.4-3.2,0.6-4.8c1.2-8.8,3.4-17.5,6.2-24.8c2.5,9.8,5.7,21.9,7.2,32.8 c0.3,2,0.5,3.9,0.6,5.8c1.3-6.3,0.9-14.5-0.4-22.8c-1.5-9.2-4.4-18.6-7.7-25.6c-1.4,5.6-4,12.1-5.9,18.4c-0.9,2.9-1.6,5.8-2,8.5 L251.1,508.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M483.3,357.7c0.1,1.1,0.1,2.3,0.1,3.5c-0.2,5.6-1.8,12-4,16c-1.4-2.7-4.8-8.9-6.9-17.1 c-0.3-1.3-0.6-2.6-0.9-3.9l0.4,8.4c0.4,1.8,1,3.7,1.7,5.6c1.6,4,3.8,8,5.7,10.7c2.1-3.7,3.7-7.9,4.4-12.4 C484.4,365.1,484.3,361.4,483.3,357.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHairstyle1A);
export default __webpack_public_path__ + "static/media/new_hairstyle_1a.3922b5c16277bf58e97a0006451cfc84.svg";
export { ForwardRef as ReactComponent };